import React, { useState, useEffect } from 'react'
import { pathname, getRequest, postRequest } from '@react/helpers/fetch'
import GithubIssueDetail from '@shared/github/IssueDetail'

const MODAL_ID     = '#github-card'
const FETCH_PATH   = '/tickets/:id/github_issue'
const COMMENT_PATH = '/tickets/:id/comment_github_issue'

const GithubCard = ({ ticketId, issueUrl }) => {
  const [issue,   setIssue]   = useState(null)
  const [loading, setLoading] = useState(false)
  const [error,   setError]   = useState(null)
  const [comment, setComment] = useState('')
  const [posting, setPosting] = useState(false)

  const fetchIssue = () => {
    setLoading(true)
    setError(null)
    const url = pathname({ path: FETCH_PATH.replace(':id', ticketId), format: 'json' })
    getRequest(url)
      .then(data => {
        if (data && data.error) {
          setError(data.error)
        } else {
          setIssue(data)
        }
      })
      .catch(() => setError(I18n.t('tickets.github_card.fetch_error')))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    const $modal = window.$ ? window.$(MODAL_ID) : null
    if (!$modal) return

    const onShown = () => fetchIssue()
    $modal.on('shown.bs.modal', onShown)
    return () => $modal.off('shown.bs.modal', onShown)
  }, [ticketId])

  const submitComment = () => {
    if (posting || !comment.trim()) return

    setPosting(true)
    const url = pathname({ path: COMMENT_PATH.replace(':id', ticketId), format: 'json' })
    postRequest({ url, body: { body: comment } })
      .then(data => {
        if (data && data.error) {
          setError(data.error)
          return
        }
        setComment('')
        setIssue(prev => prev
          ? { ...prev, comments: [...(prev.comments || []), data], comments_count: (prev.comments_count || 0) + 1 }
          : prev)
      })
      .catch(() => setError(I18n.t('tickets.github_card.comment_error')))
      .finally(() => setPosting(false))
  }

  if (loading && !issue) {
    return <div className="d-flex-center" style={{ minHeight: 200 }}><div id="loading-spinner" /></div>
  }

  if (error && !issue) {
    return (
      <div className="text-center p-4">
        <p className="text-danger">{error}</p>
        {issueUrl &&
          <a href={issueUrl} target="_blank" rel="noopener noreferrer" className="btn btn-default">
            {I18n.t('tickets.github_card.open_on_github')}
          </a>}
      </div>
    )
  }

  if (!issue) return null

  return (
    <GithubIssueDetail issue={issue} showTicket={false}>
      <div className="form-group">
        <label>{I18n.t('tickets.github_card.add_comment')}</label>
        <textarea
          className   = "form-control"
          rows        = {3}
          value       = {comment}
          placeholder = {I18n.t('tickets.github_card.add_comment_placeholder')}
          onChange    = {e => setComment(e.target.value)}
        />
      </div>

      {error && <p className="text-danger">{error}</p>}

      <div className="github-card__footer">
        <a href={issue.html_url} target="_blank" rel="noopener noreferrer" className="github-card__github-link">
          {I18n.t('tickets.github_card.open_on_github')}
        </a>
        <button
          type="button"
          className="btn btn-primary"
          onClick={submitComment}
          disabled={posting || !comment.trim()}
        >
          {I18n.t('tickets.github_card.post_comment')}
        </button>
      </div>
    </GithubIssueDetail>
  )
}

export default GithubCard
